import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-483a182e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-fullscreen" }

import {provide} from "vue";
import {EasClientKey, FreezeClientKey} from "@/apps/freeze/DI";
import {FreezeClient} from "@/apis/freeze/FreezeClient";
import {EasClient} from "@/apis/freeze/EasClient";


import {defineComponent} from "vue";

const __default__ = defineComponent({
	name: 'Freeze',
	setup() {
		return {}
	},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

provide(FreezeClientKey, FreezeClient.getInstance())
provide(EasClientKey, EasClient.getInstance());

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})